module.exports = __webpack_public_path__ + "static/media/ajax-Loader.a937b818.gif";